import type { CSSProperties, JSX } from "react";
import { ICON_KEYS, iconRegistry } from "@/icons/icon-registry";
import { AXIS_LABEL_COLOR } from "../layout/plot-geometry";
import { ACTUAL_COLOR, SCHEDULED_BORDER, SCHEDULED_BORDER_PX, SCHEDULED_FILL } from "./band-geometry";
import { formatHours } from "./band-totals";

const WaterdropIcon = iconRegistry[ICON_KEYS.WATERDROP];

const SCHEDULED_SWATCH = {
    backgroundColor: SCHEDULED_FILL,
    border: `${SCHEDULED_BORDER_PX}px solid ${SCHEDULED_BORDER}`,
};
const ACTUAL_SWATCH = { backgroundColor: ACTUAL_COLOR };

function Row({ label, ms, swatchStyle }: { label: string; ms: number; swatchStyle: CSSProperties }) {
    return (
        <div className={"flex min-w-0 items-center gap-[6px]"}>
            <span aria-hidden className={"h-[8px] w-[10px] shrink-0 rounded-[2px]"} style={swatchStyle} />
            <span className={"truncate"}>
                {label} · <span className={"text-foreground tabular-nums"}>{formatHours(ms)}</span>
            </span>
        </div>
    );
}

export function BandLegend({ scheduledMs, actualMs }: { scheduledMs: number; actualMs: number }): JSX.Element {
    return (
        <div
            className={
                "flex min-w-0 flex-wrap items-center justify-start gap-x-[18px] gap-y-[6px] border-t pt-[12px] text-[11px] leading-[14px]"
            }
            style={{ color: AXIS_LABEL_COLOR }}
        >
            <div className={"flex min-w-0 gap-[4px] font-medium"}>
                <WaterdropIcon aria-hidden style={{ fontSize: 14 }} />
                <span className={"pt-[1px]"}>Irrigation</span>
            </div>
            <Row label={"Scheduled"} ms={scheduledMs} swatchStyle={SCHEDULED_SWATCH} />
            <Row label={"Valve open"} ms={actualMs} swatchStyle={ACTUAL_SWATCH} />
        </div>
    );
}
